// source: pbtypes/tools/cloud_api/landing_results.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

goog.exportSymbol('proto.cloud_api.LandingResults', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud_api.LandingResults = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cloud_api.LandingResults, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud_api.LandingResults.displayName = 'proto.cloud_api.LandingResults';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud_api.LandingResults.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud_api.LandingResults.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud_api.LandingResults} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud_api.LandingResults.toObject = function(includeInstance, msg) {
  var f, obj = {
batteryConnectedToCradle: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
vehicleSeatedCorrectlyInCradle: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
landingSequenceSuccessful: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
landingSequenceComplete: jspb.Message.getBooleanFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud_api.LandingResults}
 */
proto.cloud_api.LandingResults.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud_api.LandingResults;
  return proto.cloud_api.LandingResults.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud_api.LandingResults} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud_api.LandingResults}
 */
proto.cloud_api.LandingResults.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBatteryConnectedToCradle(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setVehicleSeatedCorrectlyInCradle(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setLandingSequenceSuccessful(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setLandingSequenceComplete(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud_api.LandingResults.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud_api.LandingResults.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud_api.LandingResults} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud_api.LandingResults.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBatteryConnectedToCradle();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getVehicleSeatedCorrectlyInCradle();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getLandingSequenceSuccessful();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getLandingSequenceComplete();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * optional bool battery_connected_to_cradle = 1;
 * @return {boolean}
 */
proto.cloud_api.LandingResults.prototype.getBatteryConnectedToCradle = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.LandingResults} returns this
 */
proto.cloud_api.LandingResults.prototype.setBatteryConnectedToCradle = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional bool vehicle_seated_correctly_in_cradle = 2;
 * @return {boolean}
 */
proto.cloud_api.LandingResults.prototype.getVehicleSeatedCorrectlyInCradle = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.LandingResults} returns this
 */
proto.cloud_api.LandingResults.prototype.setVehicleSeatedCorrectlyInCradle = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional bool landing_sequence_successful = 3;
 * @return {boolean}
 */
proto.cloud_api.LandingResults.prototype.getLandingSequenceSuccessful = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.LandingResults} returns this
 */
proto.cloud_api.LandingResults.prototype.setLandingSequenceSuccessful = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional bool landing_sequence_complete = 4;
 * @return {boolean}
 */
proto.cloud_api.LandingResults.prototype.getLandingSequenceComplete = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.LandingResults} returns this
 */
proto.cloud_api.LandingResults.prototype.setLandingSequenceComplete = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


goog.object.extend(exports, proto.cloud_api);
